import React from 'react'
import { useState,useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { ReactComponent as FilterIcon} from '../../../images/icons/filter.svg'
import Dropdown from './dropdown';
import FilterFunctions from '../../../functions/public/filter';
import Mobiledropdown from './mobiledropdown';

const Mobilebar = ({baseUrl, searchParams}) => {
    const [isFilterOpened, setFilterOpened] = useState(false);
    const navigate = useNavigate();
    const [allcategoryList,setAllCategoryList] = useState([]);
    const [categoryList,setCategoryList] = useState([]);
    const [subcategoryList,setSubCategoryList] = useState([]);
    const [brandList,setBrandList] = useState([]);
    const [conditionList,setConditionList] = useState([]);
    const [colorList,setColorList] = useState([]);


    useEffect(()=>{
        FilterFunctions.Category(setAllCategoryList)
        FilterFunctions.Brand(setBrandList)
        FilterFunctions.Condition(setConditionList)
        FilterFunctions.Color(setColorList)
    },[])

    useEffect(()=>{
        var collectionListSend = [];
        for (let index = 0; index < allcategoryList.length; index++) {
          const element = allcategoryList[index];
          if(element.parentid === 0){
            collectionListSend.push({
              name: element.title,
              id: String(element.id)
            })
          }
        }
        setCategoryList(collectionListSend);
        var scol = searchParams.get('category') || 0;
        if(scol != 0){
            var subcollectionListSend = [];
            for (let index = 0; index < allcategoryList.length; index++) {
              const element = allcategoryList[index];
              if(element.parentid === parseInt(scol)){
                subcollectionListSend.push({
                  name: element.title,
                  id: String(element.id)
                })
              }
            }
            setSubCategoryList(subcollectionListSend);
        }
    },[allcategoryList,searchParams.get('category')])

    const changeCategory = (e)=>{ 
        var category = "category="+e;
        var subcategory = "";
        var brand = "";
        var condition = "";
        var color = "";
        var size = "";
        var orderby = "";
        if(searchParams.get('brand')){
            brand = `&brand=${searchParams.get('brand')}`
        }
        if(searchParams.get('condition')){
            condition = `&condition=${searchParams.get('condition')}`
        }
        if(searchParams.get('color')){
            color = `&color=${searchParams.get('color')}`
        }
        if(searchParams.get('size')){
            size = `&size=${searchParams.get('size')}`
        }
        if(searchParams.get('orderby')){
            orderby = `&orderby=${searchParams.get('orderby')}`
        }
        navigate(`/${baseUrl}?${category}${subcategory}${brand}${condition}${color}${size}${orderby}`);
    }
    const changeSubCategory = (e)=>{ 
        var category = "";
        var subcategory = "&subcategory="+e;
        var brand = "";
        var condition = "";
        var color = "";
        var size = "";
        var orderby = "";
        if(searchParams.get('category')){
            category = `category=${searchParams.get('category')}`
        }
        if(searchParams.get('brand')){
            brand = `&brand=${searchParams.get('brand')}`
        }
        if(searchParams.get('condition')){
            condition = `&condition=${searchParams.get('condition')}`
        }
        if(searchParams.get('color')){
            color = `&color=${searchParams.get('color')}`
        }
        if(searchParams.get('size')){
            size = `&size=${searchParams.get('size')}`
        }
        if(searchParams.get('orderby')){
            orderby = `&orderby=${searchParams.get('orderby')}`
        }
        navigate(`/${baseUrl}?${category}${subcategory}${brand}${condition}${color}${size}${orderby}`);
    }

    const changeSort = (e)=>{ 
        var category = "";
        var subcategory = "";
        var brand = "";
        var condition = "";
        var color = "";
        var size = "";
        var orderby = `&orderby=${e}`;
        if(searchParams.get('category')){
            category = `category=${searchParams.get('category')}`
        }
        if(searchParams.get('subcategory')){
            subcategory = `&subcategory=${searchParams.get('subcategory')}`
        }
        if(searchParams.get('brand')){
            brand = `&brand=${searchParams.get('brand')}`
        }
        if(searchParams.get('condition')){
            condition = `&condition=${searchParams.get('condition')}`
        }
        if(searchParams.get('color')){
            color = `&color=${searchParams.get('color')}`
        }
        if(searchParams.get('size')){
            size = `&size=${searchParams.get('size')}`
        }
        navigate(`/${baseUrl}?${category}${subcategory}${brand}${condition}${color}${size}${orderby}`);
    }

    const changeBrand = (e)=>{ 
        var category = "";
        var subcategory = "";
        var brand = "&brand="+e;
        var condition = "";
        var color = "";
        var size = "";
        var orderby = "";
        if(searchParams.get('category')){
            category = `category=${searchParams.get('category')}`
        }
        if(searchParams.get('subcategory')){
            subcategory = `&subcategory=${searchParams.get('subcategory')}`
        }
        if(searchParams.get('condition')){
            condition = `&condition=${searchParams.get('condition')}`
        }
        if(searchParams.get('color')){
            color = `&color=${searchParams.get('color')}`
        }
        if(searchParams.get('size')){
            size = `&size=${searchParams.get('size')}`
        }
        if(searchParams.get('orderby')){
            orderby = `&orderby=${searchParams.get('orderby')}`
        }
        navigate(`/${baseUrl}?${category}${subcategory}${brand}${condition}${color}${size}${orderby}`);
    }

    const changeCondition = (e)=>{ 
        var category = "";
        var subcategory = "";
        var brand = "";
        var condition = "&condition="+e;
        var color = "";
        var size = "";
        var orderby = "";
        if(searchParams.get('category')){
            category = `category=${searchParams.get('category')}`
        }
        if(searchParams.get('subcategory')){
            subcategory = `&subcategory=${searchParams.get('subcategory')}`
        }
        if(searchParams.get('brand')){
            brand = `&brand=${searchParams.get('brand')}`
        }
        if(searchParams.get('color')){
            color = `&color=${searchParams.get('color')}`
        }
        if(searchParams.get('size')){
            size = `&size=${searchParams.get('size')}`
        }
        if(searchParams.get('orderby')){
            orderby = `&orderby=${searchParams.get('orderby')}`
        }
        navigate(`/${baseUrl}?${category}${subcategory}${brand}${condition}${color}${size}${orderby}`);
    }
    const changeColor = (e)=>{ 
        var category = "";
        var subcategory = "";
        var brand = "";
        var condition = "";
        var color = "&color="+e;
        var size = "";
        var orderby = "";
        if(searchParams.get('category')){
            category = `category=${searchParams.get('category')}`
        }
        if(searchParams.get('subcategory')){
            subcategory = `&subcategory=${searchParams.get('subcategory')}`
        }
        if(searchParams.get('brand')){
            brand = `&brand=${searchParams.get('brand')}`
        }
        if(searchParams.get('condition')){
            condition = `&condition=${searchParams.get('condition')}`
        }
        if(searchParams.get('size')){
            size = `&size=${searchParams.get('size')}`
        }
        if(searchParams.get('orderby')){
            orderby = `&orderby=${searchParams.get('orderby')}`
        }
        navigate(`/${baseUrl}?${category}${subcategory}${brand}${condition}${color}${size}${orderby}`);
    }
  return (
    <div className='filter_mobilebar_container'>
      <div className='filter_mobilebar_opener' onClick={()=>{setFilterOpened(!isFilterOpened)}}>
        <h3>Filters</h3>
        <FilterIcon />
      </div>
    {isFilterOpened &&
        <div className='filters_items_main_container'>
            <Mobiledropdown Lable={"Category"} SetValue={changeCategory} Value={searchParams.get('category') || "0" } Options={categoryList}/>
            <Mobiledropdown Lable={"Sub Category"} SetValue={changeSubCategory} Value={searchParams.get('subcategory') || "0" } Options={subcategoryList}/>
            <Mobiledropdown Lable={"Brand"} SetValue={changeBrand} Value={searchParams.get('brand') || "0" } Options={brandList}/>
            <Mobiledropdown Lable={"Condition"} SetValue={changeCondition} Value={searchParams.get('condition') || "0" } Options={conditionList}/>
            <Mobiledropdown Lable={"Color"} SetValue={changeColor} Value={searchParams.get('color') || "0" } Options={colorList}/>
        </div>
    }
    </div>
  )
}

export default Mobilebar
